import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const callout = theme => css`
  display: flex;
  align-items: center;
  height: 100vh;
  padding: ${theme.spacing['14']};
  font-family: ${theme.font.tertiary};

  @media only screen and (max-width: ${theme.breakpoints.computerBreakpoint}) {
    display: none;
  }
`

const card = theme => css`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${rem(560)};
  max-height: 100%;
  margin-right: auto;
  padding: ${theme.spacing['10']};
  border-radius: ${rem(20)};
  background-color: ${theme.color.info['900']};
  color: #fff;
  overflow: hidden;
`

const imageWrapper = theme => css`
  position: relative;
  width: 100%;
  border-radius: ${rem(12)};
  overflow: hidden;
  flex-shrink: 0;
  margin-bottom: ${theme.spacing['10']};

  &::before {
    content: '';
    display: block;
    padding-bottom: 56.04%;
  }

  img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

const body = theme => css`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: ${theme.spacing['3']};
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 3px;
  }
`

const eyebrow = theme => css`
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.semibold};
  text-transform: uppercase;
  letter-spacing: 0.08em !important;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: ${theme.spacing['5']};
`

const title = theme => css`
  font-size: ${theme.fontSize.x4large};
  font-weight: ${theme.fontWeight.bold};
  line-height: ${theme.lineHeight.leadingTight};
  margin: 0 0 ${theme.spacing['7']};
  color: #fff;
`

const byline = theme => css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing['7']};
  margin-bottom: ${theme.spacing['10']};
`

const avatar = css`
  width: ${rem(40)};
  height: ${rem(40)};
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
`

const bylineText = css`
  display: flex;
  flex-direction: column;
  line-height: 1.3;
`

const bylineName = theme => css`
  font-size: ${theme.fontSize.large};
  font-weight: ${theme.fontWeight.semibold};
  color: #fff;
`

const bylineRole = theme => css`
  font-size: ${theme.fontSize.small};
  font-weight: ${theme.fontWeight.normal};
  color: rgba(255, 255, 255, 0.6);
`

const lead = theme => css`
  font-size: ${theme.fontSize.x2large};
  font-weight: ${theme.fontWeight.semibold};
  line-height: ${theme.lineHeight.leadingNormal};
  margin: 0 0 ${theme.spacing['7']};
`

const paragraph = theme => css`
  font-size: ${theme.fontSize.large};
  font-weight: ${theme.fontWeight.normal};
  line-height: ${theme.lineHeight.leadingNormal};
  color: rgba(255, 255, 255, 0.75);
  margin: 0 0 ${theme.spacing['7']};

  &:last-of-type {
    margin-bottom: ${theme.spacing['10']};
  }
`

const cta = theme => css`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: ${theme.spacing['7']} ${theme.spacing['12']};
  border-radius: ${rem(200)};
  background-color: #fff;
  color: ${theme.color.info['900']};
  font-size: ${theme.fontSize.x2large};
  font-weight: ${theme.fontWeight.semibold};
  text-decoration: none;
  transition: background-color 0.15s ease;
  margin-top: auto;
  flex-shrink: 0;

  &:hover {
    background-color: rgba(255, 255, 255, 0.88);
    color: ${theme.color.info['900']};
  }

  &:hover svg {
    transform: translateX(${rem(4)});
  }

  svg {
    margin-left: ${theme.spacing['5']};
    transition: transform 0.2s ease;
  }
`

export const styles = {
  callout,
  card,
  imageWrapper,
  body,
  eyebrow,
  title,
  byline,
  avatar,
  bylineText,
  bylineName,
  bylineRole,
  lead,
  paragraph,
  cta,
}
